import type {
  BoardBuilderFilters,
  CorrelationsFilters,
  DepositsFilters,
  PlayerPacksFilters,
  ScoringFilters,
  SimulationsFilters,
  StreakFilters,
  TradingFilters,
  WithdrawalsFilters
} from '@library/types/filters';
import { SELECT_ALL } from '@library/component-utils/filters';
import type { SelectOptions } from '@library/types/utils';

export const DNP_OPTIONS: SelectOptions = [
  { display: 'DNP', key: 'DNP', name: 'DNP', value: 'true' },
  { display: 'Not DNP', key: 'Not DNP', name: 'Not DNP', value: 'false' }
];

export const REBOOT_OPTIONS: SelectOptions = [
  { display: 'Rebooted', key: 'Rebooted', name: 'Rebooted', value: 'true' },
  {
    display: 'Not Rebooted',
    key: 'Not Rebooted',
    name: 'Not Rebooted',
    value: 'false'
  }
];

export const IN_GAME_OPTIONS: SelectOptions = [
  { key: 'in_game_enabled', name: 'In Game Enabled', value: 'true' },
  { key: 'in_game_disabled', name: 'In Game Disabled', value: 'false' }
];

export const DEMONS_AND_GOBLINS_OPTIONS: SelectOptions = [
  { key: 'demons_and_goblins', name: 'D&G', value: 'true' },
  { key: 'median', name: 'Median', value: 'false' }
];

export const IS_SAME_TEAM_OPTIONS: SelectOptions = [
  { key: 'is_same_team', name: 'Same Team', value: 'true' },
  { key: 'not_same_team', name: 'Different Team', value: 'false' }
];

export const MORE_OR_LESS_OPTIONS: SelectOptions = [
  { key: 'More', name: 'More', value: 'More' },
  { key: 'Less', name: 'Less', value: 'Less' }
];

export const DEFAULT_SCORING_FILTERS: ScoringFilters = {
  dnp: '',
  durations: [],
  gameModes: [],
  games: [],
  reboot: '',
  statType: [],
  status: [],
  teams: []
};

export const DEFAULT_TRADING_FILTERS: TradingFilters = {
  demonsAndGoblins: '',
  duration: '',
  gameModes: [],
  games: [],
  inGame: '',
  statType: [],
  status: [],
  teams: []
};

export const DEFAULT_CORRELATIONS_FILTERS: CorrelationsFilters = {
  firstChoice: '',
  isSameTeam: '',
  position1: [],
  position2: [],
  secondChoice: '',
  statType1: [],
  statType2: []
};

export const DEFAULT_BOARD_BUILDER_FILTERS: BoardBuilderFilters = {
  games: [],
  positions: [],
  teams: []
};

export const DEFAULT_DEPOSITS_FILTERS: DepositsFilters = {
  depositStatus: SELECT_ALL,
  depositMethodType: SELECT_ALL
};

export const DEFAULT_WITHDRAWALS_FILTERS: WithdrawalsFilters = {
  withdrawalStatus: SELECT_ALL,
  withdrawalMethod: SELECT_ALL
};

export const DEFAULT_SIMULATIONS_FILTERS: SimulationsFilters = {
  game: ''
};

export const DEFAULT_STREAK_FILTERS: StreakFilters = {
  games: [],
  positions: [],
  teams: []
};

export const DEFAULT_PLAYER_PACKS_FILTERS: PlayerPacksFilters = {
  demonsAndGoblins: '',
  duration: '',
  games: [],
  statType: [],
  teams: []
};
